(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["try-on-button"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('#spreeai-try-on');

  if (container && !container.dataset.initialized) {
    container.dataset.initialized = 'true';

    const garmentId = container.dataset.garmentId;

    let garments = [{ garmentId }];

    import('https://unpkg.com/@spreeai/web-sdk@3.0.0/dist/@spreeai/web-sdk.js')
      .then(async ({ init }) => {
        const spreeAI = await init({
          clientId: '167134e0-9d01-0000-0100-cfe22650e0cf',
        });

        if (!spreeAI) {
          return;
        }

        spreeAI.renderTryOnButton({
          garments: garments,
          defaultUnits: 'metric',
          elementId: 'spreeai-try-on',
          features: {
            tryOnButton: {
              text: garments.length > 1 ? 'Try This Look' : 'TRY IT ON',
            },
          },
        });
      })
      .catch((error) => {
        console.error('Failed to load SpreeAI SDK', error);
      });
  }
  } catch(e) { console.error(e); }
})();

})();
